import {
  BenchmarkStatisticsPerMonth,
  MonthlyStatistics,
} from '@tassomutuo-backoffice/types';
import { Box, Typography } from '@mui/material';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import React from 'react';
import { format, parse } from 'date-fns';
import { it } from 'date-fns/locale';

interface IProps {
  statisticsPerMonth: MonthlyStatistics;
  benchmarkStatisticsPerMonth?: BenchmarkStatisticsPerMonth;
  isPrinting?: boolean;
  reverse?: boolean;
}

const DashboardEstimatedMortgagesChart = ({
  statisticsPerMonth,
  benchmarkStatisticsPerMonth,
  isPrinting,
  reverse = true,
}: IProps) => {
  const chartData = Object.entries(statisticsPerMonth).map(([month, stats]) => {
    const estimatedMortgagesBench = benchmarkStatisticsPerMonth?.find(
      (m) => m.month === month
    )?.statistics.estimatedMortgages;

    return {
      month,
      estimatedMortgages: stats.estimatedMortgages,
      estimatedMortgagesBench,
    };
  });

  if (reverse) {
    chartData.reverse();
  }

  return (
    <Box
      sx={{
        backgroundColor: '#FAFAFA',
        padding: 4,
        mt: 6,
        borderRadius: '16px',
        border: '1px solid gainsboro',
      }}
    >
      <Typography variant="h4" mb={1} fontWeight="bold">
        Mutui Stimati
      </Typography>
      <Typography variant="h6" mb={4}>
        Mutui che stimiamo andrai ad erogare sulla base degli aggiornamenti
        ricevuti sulle lead del periodo selezionato
      </Typography>
      <Box
        sx={{
          width: '100%',
          p: 2,
          height: 400,
          minWidth: isPrinting ? 1000 : undefined,
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <Line
              type="monotone"
              dataKey="estimatedMortgages"
              stroke="rgba(59, 130, 246, 1)"
              strokeWidth={4}
            />
            {/*<Line
              type="monotone"
              dataKey="estimatedMortgagesBench"
              strokeWidth={4}
              stroke="rgba(16, 60, 85, 1)"
            />*/}
            <CartesianGrid
              stroke="#ccc"
              strokeDasharray="3 3"
              vertical={false}
            />
            <XAxis
              dataKey="month"
              tickFormatter={(month) => {
                const date = parse(month, 'MMMM yyyy', new Date(), {
                  locale: it,
                });
                return format(date, 'MMM yy', { locale: it });
              }}
            />
            <YAxis domain={[0, (dataMax: number) => Math.ceil(dataMax * 1.1)]} />
            <Tooltip
              //labelFormatter={(label) => `Mese: ${label}`}
              formatter={(value, dataType) => {
                const isBench = dataType === 'estimatedMortgagesBench';
                const formattedValue = typeof value === 'number' ? value.toFixed(2) : value;
                return [`${formattedValue}`, isBench ? 'Benchmark' : 'Mutui Stimati'];
              }}
            />
            <Legend
              formatter={(value) => {
                switch (value) {
                  case 'estimatedMortgages':
                    return 'Mutui Stimati';
                  case 'estimatedMortgagesBench':
                    return 'Mutui Stimati Benchmark';
                  default:
                    return value;
                }
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default DashboardEstimatedMortgagesChart;
